import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import filterByStyle from './FilterBy.styles';
import { Chip, Collapse, List, ListItem, Button, Typography } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import { colors } from 'theme/color-palette';
import { FILTER_BY, NOW, TODAY, LATER } from 'constants/constant';
import { isObjEmpty } from 'helper/helper';
import { dbFilterBy } from '../Dashboard.actions';

const { PURPLE } = colors;

const MyButton = withStyles(() => ({
	root: {
		textDecoration: 'underline',
		fontSize: 16,
		fontWeight: 300,
		color: PURPLE,
		marginBottom: 0,
		padding: 0,
		'&:hover': {
			fontWeight: 400,
			textDecoration: 'underline',
			backgroundColor: 'white'
		}
	},
	label: {
		'&:hover': {
			fontWeight: 400
		}
	}
}))(Button);

/* Accessibility  example: https://a11y-guidelines.orange.com/en/web/components-examples/tags/examples/filter-by-brand/ */
const FilterBy = () => {
	const { filterBy } = useSelector((state) => state.dashboardReducer);
	const classes = filterByStyle();
	const dispatch = useDispatch();

	const deleteFilter = (el) => {
		if (el === 'All') {
			dispatch(dbFilterBy({}));
		} else {
			let sf = {};
			Object.keys(filterBy).forEach((item) => {
				if (filterBy[item][0] === el) {
					delete filterBy[item];
					sf = { ...filterBy };
				}
			});
			dispatch(dbFilterBy(sf));
		}
	};

	if (isObjEmpty(filterBy)) {
		return null;
	}

	return (
		<Collapse in={Object.keys(filterBy).length > 0}>
			<div className={classes.list}>
				<Typography className={classes.text}>{FILTER_BY}</Typography>
				<List className={classes.list}>
					{Object.keys(filterBy).map((item, index) => {
						const filterLabel = [NOW, TODAY, LATER].includes(filterBy[item][0])
							? 'Once'
							: filterBy[item][0];
						return (
							<ListItem key={`filterBy[item][0]${index}`} classes={{ root: classes.item }}>
								<Chip
									className={classes.chip}
									label={filterLabel}
									onDelete={() => deleteFilter(filterBy[item][0])}
									clickable
									deleteIcon={<CloseIcon />}
								/>
							</ListItem>
						);
					})}
					<ListItem key="button" className={classes.filterByPadding}>
						<MyButton onClick={() => deleteFilter('All')} className={classes.button}>
							Clear All
						</MyButton>
					</ListItem>
				</List>
			</div>
		</Collapse>
	);
};

FilterBy.propTypes = {
	handleDelete: PropTypes.func
};

export default React.memo(FilterBy);
